
@switch (this.voiceNoteService?.permission) {
  @case ('denied') {
    <ng-container *ngTemplateOutlet="denied"></ng-container>
  }
  @case ('prompt') {
    <ng-container *ngTemplateOutlet="prompt"></ng-container>
  }
  @default {
    <ng-container *ngTemplateOutlet="waveContainer"></ng-container>
  }
}

<ng-template #denied>
  <div class="permission-container">
    <img class="permission-container-img" src='./assets/svg/redesign/Alert_traingle-filled.svg' />
    <div class="permission-container-content">
      <div class="permission-container-header">Microphone Blocked</div>
      <div class="permission-container-message">
        You have denied access to your microphone.
        <a
          class="permission-container-message-link"
          href="https://clickatell.gitbook.io/flow"
          target="_blank"
          >Need help?</a
          >
        </div>
        <button class="cancelBtn" (click)="cancelBtn()">Cancel</button>
      </div>
    </div>
  </ng-template>

  <ng-template #prompt>
    <div class="permission-container">
      <img class="permission-container-img" src='./assets/svg/redesign/Alert_traingle-filled.svg' />
      <div class="permission-container-content">
        <div class="permission-container-header">Allow Microphone</div>
        <div class="permission-container-message">
          Please allow access to your microphone to continue
        </div>
        <button class="cancelBtn" (click)="cancelBtn()">Cancel</button>
      </div>
    </div>
  </ng-template>

  <ng-template #waveContainer>
    @if (!recording) {
      <div
        [ngClass]="{ 'preview-voicenote-out': messageSource, 'preview-voicenote-in': !messageSource }"
        >
        <div class="voice-note-container">
          @if (messageSource) {
            <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
          }
          <button class="preview-player-button" (click)="onPlay()">
            <img #playBtnImg class="preview-playerBtn-image" src='./assets/svg/Play.svg' />
          </button>
          <div class="wave-container">
            <div #wave class="preview-voicenote-wave"></div>
          </div>
          <div
                [ngClass]="{
          'preview-voicenote-line-out': messageSource,
          'preview-voicenote-line-in': !messageSource
        }"
          ></div>
          <label class="preview-voicenote-timeLabel">{{ this.voiceNoteService?.timeStamp }}</label>
        </div>
      </div>
    } @else {
      <div class="voice-note">
        <button class="voice-note-cancel-button" (click)="cancelBtn()">
          <img class="preview-cancelBtn-image" />
        </button>
        <div class="voice-note-wave-container">
          <div #wave class="voice-note-voicenote-wave"></div>
          <div class="voice-note-wave-line"></div>
        </div>
        <label class="voice-note-timeStamp">-{{ this.voiceNoteService?.timeStamp }}</label>
        <button #sendButton class="voice-note-sendBtn">
          <img class="voice-note-sendBtn-image" />
        </button>
      </div>
    }
  </ng-template>
